import React from 'react';
import PropTypes from 'prop-types';
import AvatarEditor from 'react-avatar-editor';
import {t} from 'common/utils/translation-util';

export default class ImageCropperModal extends React.Component {
  static propTypes = {
    border: PropTypes.number,
    height: PropTypes.number,
    image: PropTypes.string.isRequired,
    modalTitle: PropTypes.string,
    onCancel: PropTypes.func.isRequired,
    onOK: PropTypes.func.isRequired,
    width: PropTypes.number,
  };

  constructor(props, context) {
    super(props, context);
    this.handleScale = this.handleScale.bind(this);
  }

  state = {
    scale: 1,
  };

  render() {
    return (
      <div>
        <div className='modal-header'>
          <button className='close' data-dismiss='modal' type='button'>
            {/* eslint-disable */}
            &times;
            {/* eslint-enable */}
          </button>
          <h3>{this.props.modalTitle || 'Crop Image'}</h3>
        </div>
        <div className='modal-body'>
          <div style={{margin: '0 auto', width: '350px'}}>
            <AvatarEditor
              border={this.props.border || 50}
              color={[255, 255, 255, 0.8]}
              height={this.props.height || 250}
              image={this.props.image}
              ref={(ref) => (this.avatar = ref)}
              scale={this.state.scale}
              width={this.props.width || 250}
            />
            <input
              defaultValue='1'
              max='3'
              min='1'
              name='scale'
              onChange={this.handleScale}
              ref={(ref) => (this._scale = ref)}
              step='0.01'
              style={{width: '350px'}}
              type='range'
            />
          </div>
        </div>
        <div className='modal-footer'>
          <a
            className='button--cancel'
            data-dismiss='modal'
            href='#'
            onClick={this.props.onCancel}>
            {t('Cancel')}
          </a>
          <button
            className='button--success'
            data-dismiss='modal'
            onClick={this.props.onOK}
            type={'submit'}>
            {t('Apply Crop')}
          </button>
        </div>
      </div>
    );
  }

  handleScale() {
    this.setState({
      scale: parseFloat(this._scale.value),
    });
  }
}
